exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pod-overview-full-size {\n  height: 100%; }\n\n.pod-overview-content-full-size {\n  min-height: 100%; }\n\n.pod-overview-error-height {\n  min-height: calc(100% - 64px); }\n", ""]);

// exports
